<template>
	<div class="resourceType">
		<el-card shadow="hover">
			<el-row>
				<el-col :span="12">
					<div class="grid-content bg-purple">
						<el-input placeholder="请输入内容" v-model="search_name" class="input-with-select">
							<el-select v-model="product_search" filterable slot="prepend" placeholder="请选择产品" @change="page_current=1;">
								<el-option label="全部产品" value=""> </el-option>
								<el-option v-for="item in productList" :key="item.id" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
						</el-input>
					</div>
				</el-col>
			</el-row>
		</el-card>

		<el-card shadow="hover" style="margin-top: 10px;">
			<div slot="header" class="clearfix">
				<span>资源分类列表({{tableDataCount}})</span>
				<el-button style="float: right; padding: 3px 0" type="text" @click="dialogEdit = true">添加资源分类
				</el-button>
			</div>
			<el-table :data="showDate()">
				<el-table-column fixed type="index" width="50" align="center">
					<template slot-scope="scope">
						{{(page_current-1)*page_size+scope.$index+1}}
					</template>
				</el-table-column>
				<el-table-column prop="name" label="资源分类名称" align="left">
				</el-table-column>
				<el-table-column label="所属产品" align="center">
					<template slot-scope="scope">
						{{getProductName(scope.row.productID)}}
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="创建时间" align="center" width="160" ></el-table-column>
				<el-table-column fixed="right" label="操作" align="center" width="200">
					<template slot-scope="scope">
						<el-button icon="el-icon-edit" style="margin-right: 10px;" size="mini"
							@click="dialogEdit2_data= scope.row; dialogEdit2 = true">编辑</el-button>
						<el-popconfirm confirm-button-text='确认' cancel-button-text='取消' icon="el-icon-info"
							icon-color="red" title="确定删除吗？" @confirm="del(scope.row.id)">
							<el-button slot="reference" type="danger" icon="el-icon-delete" size="mini">
								删除</el-button>
						</el-popconfirm>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="tableDataCount"
				class="pagination" @size-change="sizeChange" @current-change="currentChange">
			</el-pagination>
		</el-card>

		<editResourceType type="add" title="添加资源分类" :dialogVisible="dialogEdit" :productList='productList'
			@before-close="dialogEdit=false;loadData()" v-if="dialogEdit">
		</editResourceType>

		<editResourceType type="update" title="编辑资源分类" :dialogVisible="dialogEdit2" :productList='productList'
			@before-close="dialogEdit2=false;loadData()" :obj="dialogEdit2_data">
		</editResourceType>
	</div>
</template>

<script>
	import editResourceType from './components/editResourceType.vue'

	export default {
		data() {
			return {
				page_size: 10,
				page_current: 1,
				search_name: '',
				tableDataCount: 0,
				dialogEdit: false,
				dialogEdit2: false,
				dialogEdit2_data: null,
				productResourceArray: [],
				productList: [],
				product_search: ''
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.$http.get('api/Product/GetProductList').then(res => {
					// 过滤 显示有场景名称产品
					this.productList = res.data.data.filter(item => item.sceneName)
				})
			},
			loadData() {
				this.$http.get('api/productResource/GetResourceTypeList').then(res => {
					this.productResourceArray = res.data.data
				})
			},
			sizeChange(e) {
				this.page_size = e
			},
			currentChange(e) {
				this.page_current = e
			},
			showDate() {
				if (this.productResourceArray) {
					let _data = this.productResourceArray.filter(item => item.name && item.name.search(this.search_name) >
						-1 && item.productID.search(this.product_search) > -1)
					this.tableDataCount = _data.length
					return _data.slice((this.page_current - 1) * this.page_size, this.page_current * this.page_size)
				}
			},
			getProductName(val) {
				let product = this.productList.find(item => {
					return item.id == val
				})
				if (product) {
					return product.name
				}
				return ''
			},
			del(id) {
				this.$http.get('api/productResource/DelResourceType/' + id).then(res => {
					if (res.data.code == 1) {
						this.loadData()
					} else {
						this.$message({
							message: "删除失败：" + res.data.data,
							type: 'error'
						})
					}
				})
			}
		},
		mounted() {
			this.loadData()
		},
		components: {
			editResourceType
		}
	}
</script>
<style lang="scss">
	.resourceType {
		.el-select .el-input {
			width: 150px;
		}

		.input-with-select .el-input-group__prepend {
			background-color: #fff;
		}
		
		
		.pagination {
			margin: 10px 0;
			text-align: center;
		}
		
	}
</style>
